import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

// Mobile Accessories is now live and rendered inline on Home (see
// #accessories-section there). This route is kept only so any old bookmarks
// or links to "/accessories" don't 404 - it just forwards straight to the
// live section on Home instead of showing a "coming soon" message.
export default function AccessoriesComingSoon() {
  const navigate = useNavigate();

  useEffect(() => {
    navigate("/", { replace: true });
    // Give Home a moment to mount before scrolling to the section.
    const timer = setTimeout(() => {
      document.getElementById("accessories-section")?.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 300);
    return () => clearTimeout(timer);
  }, [navigate]);

  return null;
}